import { render } from "./LoginDialog.vue?vue&type=template&id=47780e8c&ts=true"
import script from "./LoginDialog.vue?vue&type=script&lang=ts"
export * from "./LoginDialog.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__